__turbopack_context__.v({
  "grid-container": "ReturnStatisticsCard-module-scss-module__dwjeta__grid-container",
  "grid-container-no-value": "ReturnStatisticsCard-module-scss-module__dwjeta__grid-container-no-value",
  "grid-item": "ReturnStatisticsCard-module-scss-module__dwjeta__grid-item",
});
